/*global angular */
/*jslint node: true */

'use strict';

var link = angular.module('socialmedia', []);

link.service('socialmediaSlot', ['$templateCache', function ($templateCache) {
    return {
        getTemplate: function () {
            return $templateCache.get('slots/socialmedia/socialmedia.html');
        },
        config: {
            title: 'SocialMedia',
            visible: function (context_type, context) {
                return context_type == 'slot' && context.type == 'socialmedia';
            },
            template: $templateCache.get('slots/socialmedia/socialmedia_config.html')
        }
    };
}]);
